"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FromLowercase = exports.DismissAllFromLowercase = exports.DismissAnyFromLowercase = exports.DismissFromLowercase = exports.RaiseFromLowercase = exports.Action = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Culligan.Protocol.Common.Alarm';
exports.Action = effect_1.Schema.Literal(
/**
 * Activate an alarm with the given `_tag`, and params (if specified)
 */
'Raise', 
/**
 * Deactivate an alarm with the given `_tag`, and params (if specified)
 */
'Dismiss', 
/**
 * Dismiss all alarms with the given `_tag`, regardless of alarm params
 */
'DismissAny', 
/**
 * Dismiss all firnware-based alarms
 */
'DismissAll').annotations({ identifier: `${NAMESPACE}.Action` });
exports.RaiseFromLowercase = effect_1.Schema.transformLiteral('raise', 'Raise').annotations({ identifier: `${NAMESPACE}.RaiseFromLowercase` });
exports.DismissFromLowercase = effect_1.Schema.transformLiteral('dismiss', 'Dismiss').annotations({ identifier: `${NAMESPACE}.DismissFromLowercase` });
exports.DismissAnyFromLowercase = effect_1.Schema.transformLiteral('dismissAny', 'DismissAny').annotations({ identifier: `${NAMESPACE}.DismissAnyFromLowercase` });
exports.DismissAllFromLowercase = effect_1.Schema.transformLiteral('dismissAll', 'DismissAll').annotations({ identifier: `${NAMESPACE}.DismissAllFromLowercase` });
exports.FromLowercase = effect_1.Schema.Union(exports.RaiseFromLowercase, exports.DismissFromLowercase, exports.DismissAnyFromLowercase, exports.DismissAllFromLowercase).annotations({ identifier: `${NAMESPACE}.FromLowercase` });
//# sourceMappingURL=alarm.js.map